import { ComponentProps } from 'react'

import { value } from '@karakuri-web/faq-component'
import {
  CategoryDictionary,
  CategoryLayout,
  HtmlLayout,
  IframeLayout,
  Layout,
  SearchLayout,
} from '@karakuri-web/faq-type'

import { BreadcrumbWidget } from '../BreadcrumbWidget'
import { CategoryWidget } from '../CategoryWidget'
import { HtmlWidget } from '../HtmlWidget'
import { IframeWidget } from '../IframeWidget'
import { NaviWidget } from '../NaviWidget'
import { SearchWidget } from '../SearchWidget'
import { TagWidget } from '../TagWidget'

export function renderTagPageWidget(
  layouts: readonly Layout[],
  props: ComponentProps<typeof TagWidget> & { dictionary: CategoryDictionary }
) {
  return layouts.map(layout => {
    switch (layout.type) {
      case 'navi': {
        return (
          <NaviWidget
            key={layout.id}
            botId={value(props.data.settingYaml.botId, '')}
            tenantId={value(props.data.settingYaml.tenantId, '')}
            breadcrumb={props.breadcrumb}
            breadcrumbType={props.data.settingYaml.breadcrumbType}
            relatedCategories={props.pageContext?.relatedCategories || []}
            hierarchies={props.hierarchies}
            searchWaitMs={props.data.settingYaml.waitMs?.search ?? 5000}
            topTitle={props.data.settingYaml.words?.breadcrumb?.top || 'よくあるご質問'}
            searchType={props.data.settingYaml.searchType || ''}
            data={props.data}
          />
        )
      }
      case 'tag': {
        return <TagWidget key={layout.id} {...props} />
      }
      case 'breadcrumb': {
        return (
          <BreadcrumbWidget
            key={layout.id}
            breadcrumb={props.breadcrumb}
            breadcrumbType={props.data.settingYaml.breadcrumbType}
            relatedCategories={props.pageContext?.relatedCategories || []}
            hierarchies={props.hierarchies}
            dictionary={props.dictionary}
            topTitle={props.data.settingYaml.words?.breadcrumb?.top || 'よくあるご質問'}
          />
        )
      }
      case 'category': {
        return (
          <CategoryWidget key={layout.id} layout={layout as CategoryLayout} data={props.data} />
        )
      }
      case 'search': {
        return <SearchWidget key={layout.id} layout={layout as SearchLayout} data={props.data} />
      }
      case 'html': {
        return <HtmlWidget key={layout.id} layout={layout as HtmlLayout} />
      }
      case 'iframe': {
        return <IframeWidget key={layout.id} layout={layout as IframeLayout} />
      }
      default: {
        return null
      }
    }
  })
}
